// client/src/coms/views/watch_together_parts/spotifyAuth.js

import {
  bindSpotifyDeepLinkAuth,
  clearSpotifySession as clearSpotifySessionFromProvider,
  ensureFreshSpotifySession,
  getSpotifySession,
  refreshSpotifySessionIfNeeded,
  startSpotifyLogin,
} from '../../auth/providers/spotifyAuth';

export {
  bindSpotifyDeepLinkAuth,
  ensureFreshSpotifySession,
  getSpotifySession,
  refreshSpotifySessionIfNeeded,
  startSpotifyLogin,
};

export function clearSpotifySession() {
  clearSpotifySessionFromProvider();
}

export function clearSpotifyLocalSession() {
  clearSpotifySessionFromProvider();
}

export async function completeSpotifyLoginFromUrl() {
  return null;
}